<div style="position:relative;top:33.5%;left:20%;" id="pagination-div">
    <div class="leftPageDiv" [ngClass]="{'disabled':disableLeftClick}" (click)="onPageClick('left',$event)">
        <span class="material-symbols-outlined leftPageClick" >arrow_circle_left</span>
    </div>
    <div class="rightPageDiv" [ngClass]="{'disabled':disableRightClick}" (click)="onPageClick('right',$event)">
        <span class="material-symbols-outlined rightPageClick" >arrow_circle_right</span>
    </div>
</div>
